export default __webpack_public_path__ + "static/media/rolling_shutters.afdc07b8.jpeg";